import React from "react";
import { InviteFailed } from "../../components";

export default function Invite() {
  return (
    <div>
      <>
        <InviteFailed />
      </>
    </div>
  );
}
